
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[single_post]",
      function () {
        return require("private-next-pages/resources/[single_post].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/[single_post]"])
      });
    }
  